import BasicLayout from './basicLayout';
import { IData, IOptions } from './interface';
import renderSentryReportWithVersion from './partial/sentry';

import titlePart from './partial/title';
import metaPart from './partial/meta';
import es6ShimPart from './partial/es6Shim';

class SharePageLayout<T extends IData = IData, K extends IOptions = IOptions> extends BasicLayout<T, K> {
    constructor(data: T, options: K) {
        super(data, options);
    }

    public renderTitle() {
        return titlePart();
    }

    public renderMeta() {
        return metaPart();
    }

    /**
     * @description 不能留空格
     */
    public renderPageData() {
        if (this.data.RUN_TIME === 'node') {
            return `
                <script type="text/template" id="__pageDataTemplate__">{{pageData | jsonsafe}}</script>
            `;
        } else {
            return `
                <script type="text/template" id="__pageDataTemplate__"><?= json_encode($pageData) ?></script>
            `;
        }
    }

    public renderHeaderCss() {
        let cssPart = '{{source.globalCss | default("") | safe}}\n';
        this.options.css.forEach((path: string) => {
            cssPart += `<link href="${path}" rel="stylesheet" /> \n`;
        });
        return cssPart;
    }

    public renderFooterScript() {
        let scriptPart = '{{source.globalJs | default("") | safe}}\n';
        this.options.js.forEach((path) => {
            scriptPart += `<script type="text/javascript" src="${path}"></script> \n`;
        });
        return scriptPart;
    }

    public renderHeader() {
        return `
            ${super.renderHeader()}
            ${this.renderTitle()}
            ${this.renderMeta()}
            ${this.renderHeaderCss()}
            ${this.useSentry ? renderSentryReportWithVersion(this.data, this.SYSTEM) : ''}
            ${es6ShimPart(this.data)}
        `;
    }

    public renderContent() {
        const data = this.data;
        return `<div class="inline-image-page ${data.pageClassName || ''}">
        </div>`;
    }

    public renderFooter() {
        return `
            ${this.renderPageData()}
            ${this.renderFooterScript()}
        `;
    }

    public render() {
        return super.render();
    }
}

export default SharePageLayout;
